// extracted by mini-css-extract-plugin
export var container = "_8n-0";